import type { Effect, Reducer, Subscription } from '@umijs/max';
import { getUserApplyPage, addUserApply } from './service';

type UserApplyModelType = {
  namespace: 'userApply';
  state: API.UserApplyState;
  effects: {
    fetchUserApplyPageEffect: Effect;
    refreshDataEffect: Effect;
    addUserApplyEffect: Effect;
  };
  reducers: {
    setPageData: Reducer<API.UserApplyState>;
  };
  subscriptions: {
    setup: Subscription;
  };
};

// 封装通用 effect 创建函数
const createEffect =
  (serviceFunc: any): Effect =>
  function* ({ payload, callback }, { call }) {
    try {
      const res = yield call(serviceFunc, payload);
      callback && callback(res);
    } catch (error) {
      // 确保即使发生错误也会调用 callback
      callback && callback({ code: -1, message: '请求失败，请检查网络连接' });
    }
  };

const UserApplyModel: UserApplyModelType = {
  namespace: 'userApply',

  state: {
    items: [],
    total: 0,
    current: 1,
    pageSize: 20,
  },

  effects: {
    fetchUserApplyPageEffect: function* ({ payload }, { call, put }) {
      const res = yield call(getUserApplyPage, payload);
      if (res.code === 0) {
        yield put({
          type: 'setPageData',
          payload: {
            items: res.data.items,
            total: res.data.total,
            current: res.data.current,
            pageSize: res.data.pageSize,
          },
        });
      }
    },

    refreshDataEffect: function* ({ payload }, { call, put }) {
      const res = yield call(getUserApplyPage, payload);
      if (res.code === 0) {
        yield put({
          type: 'setPageData',
          payload: {
            items: res.data.items,
            total: res.data.total,
            current: res.data.current,
            pageSize: res.data.pageSize,
          },
        });
      }
    },

    addUserApplyEffect: createEffect(addUserApply),
  },

  reducers: {
    setPageData(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },

  subscriptions: {
    setup({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname === '/userManage/userApply') {
          // 页面初始化时不自动加载数据，由组件控制
        }
      });
    },
  },
};

export default UserApplyModel;
